module.exports = __webpack_public_path__ + "static/media/project_default_preview.f26ad262.jpeg";